import {
  getGroupById,
  getAllGroups,
  createGroup,
  clearGetGroupById,
  updateGroup,
  getAllAmenityTypes,
  getAllAmenitiesRateTypes,
  getAmenitiesByGroupId,
  deleteAmenityByGroupId,
  addAmenityByGroupId,
  updateAmenityByGroupId,
  getPackagesByGroupId,
  deletePackageByGroupId,
  clearGetPackagesByGroupId,
  addPackageByGroupId,
  updatePackageByGroupId,
  clearCreateGroup,
} from "./GroupsActions";
import { createSlice } from "@reduxjs/toolkit";

interface Group {
  id: number;
  groupName: string;
}
interface InitialState {
  allGroups: Group[] | null;
  allGroupsLoading: boolean;
  allGroupsError: any | null;

  groupById: any | null;
  groupByIdLoading: boolean;
  groupByIdError: any | null;

  createGroupData: any | null;
  createGroupLoading: boolean;
  createGroupError: any | null;

  updateGroupData: any | null;
  updateGroupLoading: boolean;
  updateGroupError: any | null;

  getAmenitiesByGroupIdData: any[] | null;
  getAmenitiesByGroupIdLoading: boolean;
  getAmenitiesByGroupIdError: any | null;

  addAmenityByGroupIdData: any | null;
  addAmenityByGroupIdLoading: boolean;
  addAmenityByGroupIdError: any | null;

  updateAmenityByGroupIdData: any | null;
  updateAmenityByGroupIdLoading: boolean;
  updateAmenityByGroupIdError: any | null;

  deleteAmenityByGroupIdLoading: boolean;
  deleteAmenityByGroupIdError: any | null;

  getAllAmenityTypesData: any[] | null;
  getAllAmenityTypesLoading: boolean;
  getAllAmenityTypesError: any | null;

  getAllAmenitiesRateTypesData: any[] | null;
  getAllAmenitiesRateTypesLoading: boolean;
  getAllAmenitiesRateTypesError: any | null;

  getPackagesByGroupIdData: any[] | null;
  getPackagesByGroupIdLoading: boolean;
  getPackagesByGroupIdError: any | null;

  addPackageByGroupIdData: any | null;
  addPackageByGroupIdLoading: boolean;
  addPackageByGroupIdError: any | null;

  updatePackageByGroupIdData: any | null;
  updatePackageByGroupIdLoading: boolean;
  updatePackageByGroupIdError: any | null;

  deletePackageByGroupIdLoading: boolean;
  deletePackageByGroupIdError: any | null;
}

const initialState: InitialState = {
  allGroups: null,
  allGroupsLoading: false,
  allGroupsError: null,

  groupById: null,
  groupByIdLoading: false,
  groupByIdError: null,

  createGroupData: null,
  createGroupLoading: false,
  createGroupError: null,

  updateGroupData: null,
  updateGroupLoading: false,
  updateGroupError: null,

  getAmenitiesByGroupIdData: null,
  getAmenitiesByGroupIdLoading: false,
  getAmenitiesByGroupIdError: null,

  updateAmenityByGroupIdData: null,
  updateAmenityByGroupIdLoading: false,
  updateAmenityByGroupIdError: null,

  deleteAmenityByGroupIdLoading: false,
  deleteAmenityByGroupIdError: null,

  addAmenityByGroupIdData: null,
  addAmenityByGroupIdLoading: false,
  addAmenityByGroupIdError: null,

  getAllAmenityTypesData: null,
  getAllAmenityTypesLoading: false,
  getAllAmenityTypesError: null,

  getAllAmenitiesRateTypesData: null,
  getAllAmenitiesRateTypesLoading: false,
  getAllAmenitiesRateTypesError: null,

  getPackagesByGroupIdData: null,
  getPackagesByGroupIdLoading: false,
  getPackagesByGroupIdError: null,

  addPackageByGroupIdData: null,
  addPackageByGroupIdLoading: false,
  addPackageByGroupIdError: null,

  updatePackageByGroupIdData: null,
  updatePackageByGroupIdLoading: false,
  updatePackageByGroupIdError: null,

  deletePackageByGroupIdLoading: false,
  deletePackageByGroupIdError: null,
};

const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllGroups.pending, (state) => {
      state.allGroupsLoading = true;
      state.allGroupsError = null;
      state.allGroups = null;
    });

    builder.addCase(getAllGroups.fulfilled, (state, action) => {
      state.allGroupsLoading = false;
      state.allGroups = action.payload;
      state.allGroupsError = null;
    });

    builder.addCase(getAllGroups.rejected, (state, action) => {
      state.allGroupsLoading = false;
      state.allGroupsError = action.payload;
      state.allGroups = null;
    });

    builder.addCase(getGroupById.pending, (state) => {
      state.groupByIdLoading = true;
      state.groupByIdError = null;
      state.groupById = null;
    });

    builder.addCase(getGroupById.fulfilled, (state, action) => {
      state.groupByIdLoading = false;
      state.groupById = action.payload;
      state.groupByIdError = null;
    });

    builder.addCase(getGroupById.rejected, (state, action) => {
      state.groupByIdLoading = false;
      state.groupByIdError = action.payload;
      state.groupById = null;
    });

    builder.addCase(createGroup.pending, (state) => {
      state.createGroupLoading = true;
      state.createGroupError = null;
      state.createGroupData = null;
    });

    builder.addCase(createGroup.fulfilled, (state, action) => {
      state.createGroupLoading = false;
      state.createGroupData = action.payload;
      state.createGroupError = null;
    });

    builder.addCase(createGroup.rejected, (state, action) => {
      state.createGroupLoading = false;
      state.createGroupError = action.payload;
      state.createGroupData = null;
    });

    builder.addCase(clearGetGroupById.fulfilled, (state) => {
      state.groupByIdLoading = false;
      state.groupByIdError = null;
      state.groupById = null;
    });

    builder.addCase(updateGroup.pending, (state) => {
      state.updateGroupLoading = true;
      state.updateGroupError = null;
      state.updateGroupData = null;
    });

    builder.addCase(updateGroup.fulfilled, (state, action) => {
      state.updateGroupLoading = false;
      state.updateGroupData = action.payload;
      state.updateGroupError = null;
    });

    builder.addCase(updateGroup.rejected, (state, action) => {
      state.updateGroupLoading = false;
      state.updateGroupError = action.payload;
      state.updateGroupData = null;
    });

    builder.addCase(getAmenitiesByGroupId.pending, (state) => {
      state.getAmenitiesByGroupIdLoading = true;
      state.getAmenitiesByGroupIdError = null;
      state.getAmenitiesByGroupIdData = null;
    });

    builder.addCase(getAmenitiesByGroupId.fulfilled, (state, action) => {
      state.getAmenitiesByGroupIdLoading = false;
      state.getAmenitiesByGroupIdData = action.payload;
      state.getAmenitiesByGroupIdError = null;
    });

    builder.addCase(getAmenitiesByGroupId.rejected, (state, action) => {
      state.getAmenitiesByGroupIdLoading = false;
      state.getAmenitiesByGroupIdError = action.payload;
      state.getAmenitiesByGroupIdData = null;
    });

    builder.addCase(getAllAmenityTypes.pending, (state) => {
      state.getAllAmenityTypesLoading = true;
      state.getAllAmenityTypesError = null;
      state.getAllAmenityTypesData = null;
    });

    builder.addCase(getAllAmenityTypes.fulfilled, (state, action) => {
      state.getAllAmenityTypesLoading = false;
      state.getAllAmenityTypesData = action.payload;
      state.getAllAmenityTypesError = null;
    });

    builder.addCase(getAllAmenityTypes.rejected, (state, action) => {
      state.getAllAmenityTypesLoading = false;
      state.getAllAmenityTypesError = action.payload;
      state.getAllAmenityTypesData = null;
    });

    builder.addCase(getAllAmenitiesRateTypes.pending, (state) => {
      state.getAllAmenitiesRateTypesLoading = true;
      state.getAllAmenitiesRateTypesError = null;
      state.getAllAmenitiesRateTypesData = null;
    });

    builder.addCase(getAllAmenitiesRateTypes.fulfilled, (state, action) => {
      state.getAllAmenitiesRateTypesLoading = false;
      state.getAllAmenitiesRateTypesData = action.payload;
      state.getAllAmenitiesRateTypesError = null;
    });

    builder.addCase(getAllAmenitiesRateTypes.rejected, (state, action) => {
      state.getAllAmenitiesRateTypesLoading = false;
      state.getAllAmenitiesRateTypesError = action.payload;
      state.getAllAmenitiesRateTypesData = null;
    });

    builder.addCase(addAmenityByGroupId.pending, (state) => {
      state.addAmenityByGroupIdLoading = true;
      state.addAmenityByGroupIdError = null;
      state.addAmenityByGroupIdData = null;
    });

    builder.addCase(addAmenityByGroupId.fulfilled, (state, action) => {
      state.addAmenityByGroupIdLoading = false;
      state.addAmenityByGroupIdData = action.payload;
      state.addAmenityByGroupIdError = null;
    });

    builder.addCase(addAmenityByGroupId.rejected, (state, action) => {
      state.addAmenityByGroupIdLoading = false;
      state.addAmenityByGroupIdError = action.payload;
      state.addAmenityByGroupIdData = null;
    });

    builder.addCase(deleteAmenityByGroupId.pending, (state) => {
      state.deleteAmenityByGroupIdLoading = true;
      state.deleteAmenityByGroupIdError = null;
    });

    builder.addCase(deleteAmenityByGroupId.fulfilled, (state, action) => {
      state.deleteAmenityByGroupIdLoading = false;
      state.deleteAmenityByGroupIdError = null;
    });

    builder.addCase(deleteAmenityByGroupId.rejected, (state, action) => {
      state.deleteAmenityByGroupIdLoading = false;
      state.deleteAmenityByGroupIdError = action.payload;
    });

    builder.addCase(updateAmenityByGroupId.pending, (state) => {
      state.updateAmenityByGroupIdLoading = true;
      state.updateAmenityByGroupIdError = null;
      state.updateAmenityByGroupIdData = null;
    });

    builder.addCase(updateAmenityByGroupId.fulfilled, (state, action) => {
      state.updateAmenityByGroupIdLoading = false;
      state.updateAmenityByGroupIdData = action.payload;
      state.updateAmenityByGroupIdError = null;
    });

    builder.addCase(updateAmenityByGroupId.rejected, (state, action) => {
      state.updateAmenityByGroupIdLoading = false;
      state.updateAmenityByGroupIdError = action.payload;
      state.updateAmenityByGroupIdData = null;
    });

    builder.addCase(getPackagesByGroupId.pending, (state) => {
      state.getPackagesByGroupIdLoading = true;
      state.getPackagesByGroupIdError = null;
      state.getPackagesByGroupIdData = null;
    });

    builder.addCase(getPackagesByGroupId.fulfilled, (state, action) => {
      state.getPackagesByGroupIdLoading = false;
      state.getPackagesByGroupIdData = action.payload;
      state.getPackagesByGroupIdError = null;
    });

    builder.addCase(getPackagesByGroupId.rejected, (state, action) => {
      state.getPackagesByGroupIdLoading = false;
      state.getPackagesByGroupIdError = action.payload;
      state.getPackagesByGroupIdData = null;
    });

    builder.addCase(addPackageByGroupId.pending, (state) => {
      state.addPackageByGroupIdLoading = true;
      state.addPackageByGroupIdError = null;
      state.addPackageByGroupIdData = null;
    });

    builder.addCase(addPackageByGroupId.fulfilled, (state, action) => {
      state.addPackageByGroupIdLoading = false;
      state.addPackageByGroupIdData = action.payload;
      state.addPackageByGroupIdError = null;
    });

    builder.addCase(addPackageByGroupId.rejected, (state, action) => {
      state.addPackageByGroupIdLoading = false;
      state.addPackageByGroupIdError = action.payload;
      state.addPackageByGroupIdData = null;
    });

    builder.addCase(updatePackageByGroupId.pending, (state) => {
      state.updatePackageByGroupIdLoading = true;
      state.updatePackageByGroupIdError = null;
      state.updatePackageByGroupIdData = null;
    });

    builder.addCase(updatePackageByGroupId.fulfilled, (state, action) => {
      state.updatePackageByGroupIdLoading = false;
      state.updatePackageByGroupIdData = action.payload;
      state.updatePackageByGroupIdError = null;
    });

    builder.addCase(updatePackageByGroupId.rejected, (state, action) => {
      state.updatePackageByGroupIdLoading = false;
      state.updatePackageByGroupIdError = action.payload;
      state.updatePackageByGroupIdData = null;
    });

    builder.addCase(deletePackageByGroupId.pending, (state) => {
      state.deletePackageByGroupIdLoading = true;
      state.deletePackageByGroupIdError = null;
    });

    builder.addCase(deletePackageByGroupId.fulfilled, (state, action) => {
      state.deletePackageByGroupIdLoading = false;
      state.deletePackageByGroupIdError = null;
    });

    builder.addCase(deletePackageByGroupId.rejected, (state, action) => {
      state.deletePackageByGroupIdLoading = false;
      state.deletePackageByGroupIdError = action.payload;
    });

    builder.addCase(clearGetPackagesByGroupId.fulfilled, (state) => {
      state.getPackagesByGroupIdLoading = false;
      state.getPackagesByGroupIdError = null;
      state.getPackagesByGroupIdData = null;
    });

    builder.addCase(clearCreateGroup.fulfilled, (state) => {
      state.createGroupLoading = false;
      state.createGroupError = null;
      state.createGroupData = null;
    });
  },
});

const groupsReducer = groupsSlice.reducer;

export default groupsReducer;
